import { Formik } from 'formik';
import React, { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { getTransaction } from '../../../../store/defi/transactionsSlice';
import { toast } from 'react-hot-toast';
import { Button, IconSettings, Textarea } from '@salesforce/design-system-react';
import Agent from '../../../../store/agent';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const Notes = forwardRef((props) => {
  const dispatch = useDispatch();
  const { data, transactionId, tx_hash } = props;

  const addNote = async (data) => {
    const response = await Agent.Notes.transaction(data);
    return response.data;
  };

  const updateNote = async (data) => {
    const response = await Agent.Notes.update(data);
    return response.data;
  };

  return (
    <div className="mb-4">
      <>
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
          <Formik
            enableReinitialize
            initialValues={{
              id: data?.id || '',
              note: data?.note || '',
            }}
            onSubmit={async (values, { setSubmitting }) => {
              setSubmitting(false);

              let newData = {
                entity_id: transactionId,
                note: values.note,
                type: 'transaction',
              };

              const updateData = {
                note: {
                  entity_id: transactionId,
                  note: values.note,
                  type: 'transaction',
                },
                id: values.id,
              };

              if (newData.entity_id) {
                if (values.id) {
                  const success = await updateNote(updateData);
                  if (success) {
                    toast.success('Successfully updated');
                    dispatch(getTransaction(tx_hash));
                  }
                } else {
                  const success = await addNote(newData);
                  if (success) {
                    toast.success('Successfully added');
                  }
                }
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              resetForm,
              isSubmitting,
            }) => (
              <form
                onSubmit={handleSubmit}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    handleSubmit();
                  }
                }}
              >
                <div className="slds-form-element">
                  <div className="slds-form-element__control">
                    <Textarea
                      id="note"
                      name="note"
                      placeholder="Enter note"
                      value={values.note || ''}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={classNames(errors.note && touched.note && 'slds-has-error')}
                    />
                    {errors.note && touched.note && (
                      <div className="slds-form-element__help">{errors.note}</div>
                    )}
                  </div>
                </div>
                <div
                  style={{
                    width: '100%',
                    textAlign: 'right',
                    marginTop: '10px',
                  }}
                >
                  <IconSettings iconPath="/assets/icons">
                    <Button
                      className="modal-save-button primary-button"
                      key="save"
                      label="Save"
                      disabled={isSubmitting}
                      onClick={handleSubmit}
                      type="submit"
                      iconCategory="utility"
                      iconName="save"
                      iconPosition="left"
                    />
                  </IconSettings>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </>
    </div>
  );
});

export default Notes;
